export enum MContentHeaderAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export interface MContentHeaderTextBlock {
  aEyebrow?: {
    eyebrowText: string;
  };
  aHeader?: {
    size: string;
    headerTag: string;
    text: string;
  };
  aBody?: {
    bodyText: string;
  };
}

export interface MContentHeaderButton {
  buttonText: string;
  type: string;
  ctaLink: string;
  openInANewTab: string;
}

export interface MContentHeaderItem {
  alignment?: MContentHeaderAlignment;
  mTextBlockSimple?: MContentHeaderTextBlock;
  cta?: string;
  mButton?: MContentHeaderButton;
  secondaryCta?: string;
  mButton2?: MContentHeaderButton;
}

export interface MContentHeaderProps {
  mContentHeader: MContentHeaderItem;
}
